import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, PenLine, Calculator, Palette, Target, Hand, CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './ui';
export const Benefits = () => {
  const benefits = [{
    title: 'Lectoescritura',
    desc: 'Aprende a leer y escribir de forma natural.',
    icon: BookOpen,
    color: 'text-brand-blue',
    bg: 'bg-brand-blue/10'
  }, {
    title: 'Caligrafía',
    desc: 'Mejora los trazos y la letra cursiva e imprenta.',
    icon: PenLine,
    color: 'text-brand-pink',
    bg: 'bg-brand-pink/10'
  }, {
    title: 'Matemática',
    desc: 'Sumas, restas y números de forma divertida.',
    icon: Calculator,
    color: 'text-brand-yellow',
    bg: 'bg-brand-yellow/20'
  }, {
    title: 'Creatividad',
    desc: 'Actividades para colorear y crear sin límites.',
    icon: Palette,
    color: 'text-brand-orange',
    bg: 'bg-brand-orange/10'
  }, {
    title: 'Concentración',
    desc: 'Juegos que mejoran la atención y el enfoque.',
    icon: Target,
    color: 'text-brand-green',
    bg: 'bg-brand-green/10'
  }, {
    title: 'Motricidad',
    desc: 'Ejercicios de grafismo y coordinación fina.',
    icon: Hand,
    color: 'text-brand-blue',
    bg: 'bg-brand-blue/10'
  }];
  return <section className="py-20 bg-white" data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <SectionHeading subtitle="Todo lo que tu hijo necesita para aprender jugando" data-id="element-166">
          Beneficios del Kit
        </SectionHeading>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-167">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} whileHover={{
          y: -5
        }} className="bg-white rounded-3xl p-8 shadow-soft border border-slate-50 hover:shadow-xl transition-all" data-id="element-168">
              <div className={`w-16 h-16 rounded-2xl ${b.bg} flex items-center justify-center mb-6`} data-id="element-169">
                <b.icon className={`w-8 h-8 ${b.color}`} data-id="element-170" />
              </div>
              <h3 className="font-heading text-2xl text-brand-navy mb-3" data-id="element-171">
                {b.title}
              </h3>
              <p className="text-slate-600" data-id="element-172">{b.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};
export const ForYouChecklist = () => {
  const items = ['Tu hijo está comenzando a leer.', 'Necesita reforzar escritura.', 'Buscas actividades sin pantallas.', 'Eres docente y necesitas recursos listos.', 'Quieres enseñar jugando.', 'Necesitas mantener a los niños motivados.'];
  return <section className="py-20 bg-brand-gray" data-id="element-173">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <SectionHeading data-id="element-175">Este kit es para ti si...</SectionHeading>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-soft" data-id="element-176">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-177">
            {items.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4" data-id="element-178">
                <CheckCircle2 className="w-8 h-8 text-brand-green flex-shrink-0 mt-1" data-id="element-179" />
                <span className="text-lg md:text-xl font-medium text-slate-700" data-id="element-180">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};
export const Transition = () => <section className="py-24 bg-[#E8F2FF] relative overflow-hidden" data-id="element-181">
    <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-180" data-id="element-182">
      <svg className="relative block w-full h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-183">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-brand-gray" data-id="element-184"></path>
      </svg>
    </div>

    <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-185">
      <motion.p initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-xl md:text-2xl text-brand-navy font-medium mb-10 leading-relaxed" data-id="element-186">
        "Si quieres desarrollar habilidades de lectura, escritura y matemáticas
        sin perder tiempo buscando actividades por internet, esta es la
        herramienta definitiva."
      </motion.p>

      <motion.h2 initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="font-heading text-4xl md:text-6xl text-brand-blue mb-4" data-id="element-187">
        COLECCIÓN APRENDO Y ME DIVIERTO
      </motion.h2>

      <motion.p initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.2
    }} className="text-lg md:text-xl text-slate-600 font-semibold" data-id="element-188">
        La Base de Datos Más Completa de Recursos Educativos Infantiles.
      </motion.p>
    </div>

    <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-189">
      <svg className="relative block w-full h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-190">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-white" data-id="element-191"></path>
      </svg>
    </div>
  </section>;